 
export const PrivateEmployeeSource = Object.freeze({
    ManagerHomeLocation : 0,
    Hyperfind: 1,
});
